// extracted by mini-css-extract-plugin
export default {"pagination":"white-button_pagination__hkag4","page-link":"white-button_page-link__zZFna","button":"white-button_button__Y7y1h"};